import React, { useState } from "react";
import { Box, Tooltip, Zoom } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloseIcon from "@mui/icons-material/Close";
import { ENV_NAME } from "../utils/constants/paths";

const WA_PHONE   = ENV_NAME === "production" ? "56973853374" : "15550229837";
const WA_MESSAGE = encodeURIComponent("Hola Haulers 👋 quiero saber más sobre cómo optimizar mi última milla.");
const WA_URL     = `https://wa.me/${WA_PHONE}?text=${WA_MESSAGE}`;

/**
 * Burbuja flotante de WhatsApp — visible en toda la app para usuarios no logueados
 * o siempre (se puede condicionar con la prop `show`).
 *
 * Uso en App.js:
 *   import WhatsAppBubble from "./shared/WhatsAppBubble";
 *   // Dentro del JSX:
 *   <WhatsAppBubble />
 */
export default function WhatsAppBubble({ show = true }) {
    const [hovered, setHovered] = useState(false);

    if (!show) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 90,
                right: 24,
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: 1,
                pointerEvents: "none",
            }}
        >
            {/* Tooltip de texto al hacer hover */}
            <Zoom in={hovered} unmountOnExit>
                <Box
                    sx={{
                        bgcolor: "#fff",
                        color: "#222",
                        borderRadius: 2,
                        px: 1.5,
                        py: 0.8,
                        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                        fontSize: 13,
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                        pointerEvents: "none",
                        mb: 0.5,
                    }}
                >
                    💬 ¿Tienes dudas? Escríbenos
                </Box>
            </Zoom>

            {/* Botón principal */}
            <Box
                component="a"
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contactar por WhatsApp"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                sx={{
                    pointerEvents: "all",
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    bgcolor: "#25D366",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 16px rgba(37,211,102,0.5)",
                    cursor: "pointer",
                    textDecoration: "none",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": {
                        transform: "scale(1.08)",
                        boxShadow: "0 6px 20px rgba(37,211,102,0.6)",
                    },
                    // Pulso animado
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        bgcolor: "rgba(37,211,102,0.35)",
                        animation: "wa-pulse 2s ease-out infinite",
                    },
                    "@keyframes wa-pulse": {
                        "0%":   { transform: "scale(1)",   opacity: 0.8 },
                        "100%": { transform: "scale(1.8)", opacity: 0 },
                    },
                    position: "relative",
                }}
            >
                <WhatsAppIcon sx={{ color: "#fff", fontSize: 30 }} />
            </Box>
        </Box>
    );
}
